module.exports = __webpack_public_path__ + "static/media/bus-icon-progression.f7f49d16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-icon-progression.svg
// module id = 407
// module chunks = 0